import { dossiers, type Dossier } from '@/mocks/dossiers';

export const getDossierById = (id: string): Dossier | undefined =>
  dossiers.find((item) => item.id === id);

export const relatedDossiers = (current: Dossier, count = 3): Dossier[] => {
  const same = dossiers.filter((item) => item.id !== current.id && item.dimension === current.dimension);
  const rest = dossiers.filter((item) => item.id !== current.id && item.dimension !== current.dimension);
  return [...same, ...rest].slice(0, count);
};

export const formatHeat = (heat: number): string =>
  heat >= 10000 ? `${(heat / 10000).toFixed(1)} 万` : `${heat}`;